import React, { useContext } from 'react'
import { RenderOption } from 'app/React/Components/Main/RenderOption'
import { getOrderedOptionsCheckout } from 'utils/getOrderedOptionsCheckout'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function SecurityDepositLeasingOrderOptions() {
  const {
    cartItems,
    currentVariant,
    isAccessoryShop,
    order,
    strings
  } = useContext(ConfiguratorContext)

  const securityDepositLeasingString = strings.footer?.security_deposit_leasing ?? 'Udbetaling'
  const carString = strings.misc?.car ?? 'Bil'

  if (order.paymentType !== 'leasing') {
    return null
  }

  const options = getOrderedOptionsCheckout(currentVariant, order?.configuration ?? {}, cartItems)
    .filter((option) => parseInt(option.security_deposit_leasing) > 0)
    .map((option) => {
      return {
        ...option,
        use_leasing_price: '0',
        price: option.security_deposit_leasing
      }
    })

  return (
    <div className='config-overview__prices'>
      <div className="config-overview__title no-styling">
        <div>{securityDepositLeasingString}</div>
      </div>

      {isAccessoryShop ? null : <RenderOption option={{
        title: carString,
        use_leasing_price: '0',
        price: parseInt(order?.leasing_price_range?.security_deposit ?? 0),
      }}/>}
      {options.map((option) => (
        <RenderOption key={option.id} option={option}/>
      ))}
    </div>
  )
}
